import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
	state,
	actions,
	getters,
	mutations,
	name: 'month',
	data: () => ({
		month: ''
	}),
	props: {
		name: {
			type: String,
			default: 'month'
		},
		label: {
			type: String,
			default: 'Mês'
		},
		required: {
			type: Boolean,
			default: true
		},
		group: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapGetters([
			'ENUM',
			'currentMonth'
		])
	},
	methods: {
		...mapActions([
			'putCurrentMonth',
		]),
		changed() {

			const data = {
				index: Object.keys(this.ENUM.Month).indexOf(this.month),
				value: this.month
			};

			EventBus.$emit(`${ this.name }Changed`, data);

			this.putCurrentMonth(data);

		}
	},
	mounted() {

		this.month = this.currentMonth.value;

		EventBus.$on('yearChanged', () => {
			this.month = '';
		});

	},
	beforeDestroy() {

		EventBus.$off('yearChanged');
		EventBus.$off('monthChanged');

	}
};



// WEBPACK FOOTER //
// ./sources/components/calendar/month/index.js